import api from "@/api.js";

export default {
  state: {
    promotions: [],
    promotionsLoading: false
  },
  mutations: {
    setPromotions(state, payload) {
      state.promotions = payload;
    },
    setPromotionsLoading(state, loading) {
      state.promotionsLoading = loading;
    }
  },
  actions: {
    async loadPromotions({ commit, state }) {
      commit("setPromotionsLoading", true);
      let promotions = await api.get("promotions");
      commit("setPromotions", promotions.data);
      commit("setPromotionsLoading", false);
    },
    async savePromotion({ commit, dispatch }, payload) {
      let returnData;
      await api
        .put("promotions", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      dispatch("loadPromotions");
      return returnData;
    },
    async newPromotion({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post("promotions", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result,
            id: result.data.promotions_id
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });

      return returnData;
    },
    async promotionsUploadImage({ commit }, payload) {
      let returnData;
      await api
        .post("promotions/uploadImage", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      return returnData;
    }
  },
  getters: {
    promotions(state) {
      return state.promotions;
    },
    promotionsLoading(state) {
      return state.promotionsLoading;
    }
  }
};
